<template>
  <div class="scrollbar">
    <loader
      :pageloader_value="pageLoader"
      :type="'complete'"
      v-if="pageLoader"
    ></loader>
    <message
      :message="response_msg"
      :messageType="msg_type"
      v-if="response_msg != ''"
    ></message>
    <div class="col-12 inMiddle-area mt-2">
      <div class="row">
        <div class="col-12">
          <!-- {{ dashboardChartData }} -->
          <div class="showChartView whiteBG box-shadow">
            <div
              class="tableHead-title d-flex align-items-center justify-content-between mb-3"
            >
              <label class="font-weight-bold d-flex align-items-center colredP">
                <p
                  class="d-flex align-items-center"
                  @click.prevent="chartData('registered')"
                >
                  <span class="greenBG mr-2"></span> Total Registered
                </p>
                <p
                  class="d-flex align-items-center" 
                  @click.prevent="chartData('unverified')"
                >
                  <span class="redBG mr-2" style="background-color: var(--yellow);"></span> Unverified
                </p>
                <p
                  class="d-flex align-items-center"
                  @click.prevent="chartData('verified')"
                >
                  <span class="redBG mr-2" style="background-color: var(--pink);"></span> Verified
                </p>
                <p
                  class="d-flex align-items-center"
                  @click.prevent="chartData('funded')"
                >
                  <span class="redBG mr-2"></span> Funded
                </p>
              </label>
              <div class="rtl d-flex align-items-center">
                <ul class="selectmotr d-flex align-items-center">
                  <li>
                    <a
                      href="javascript:void(0);"
                      v-bind:class="[statInfo.interval == 'w' ? 'active' : '']"
                      v-on:click.prevent="eventInterValFl('w', 'stat')"
                      >1W</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      v-bind:class="[statInfo.interval == 'm' ? 'active' : '']"
                      v-on:click.prevent="eventInterValFl('m', 'stat')"
                      >1M</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      v-bind:class="[statInfo.interval == '3m' ? 'active' : '']"
                      v-on:click.prevent="eventInterValFl('3m', 'stat')"
                      >3M</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      v-bind:class="[statInfo.interval == '' ? 'active' : '']"
                      v-on:click.prevent="eventInterValFl('', 'stat')"
                      >All</a
                    >
                  </li>
                  <!-- <li><a href="javascript:void(0);"  v-bind:class="[statInfo.interval == 'custom' ? 'active' : '']" v-on:click.prevent="eventInterValFl('custom', 'stat')">Custom</a></li> -->
                  <li>
                    <a
                      href="javascript:void(0);"
                      v-bind:class="[
                        statInfo.interval == 'custom' ? 'active' : '',
                      ]"
                      v-on:click.prevent="openToggle = !openToggle"
                      >Custom</a
                    >
                    <div class="mainFilterBytime modHalf">
                      <div
                        class="cutDropdown pt-0 px-0 pb-4"
                        :class="openToggle ? 'active' : ''"
                      >
                        <ul class="datPickerT">
                          <li
                            class="headTitle d-flex align-items-center justify-content-between"
                          >
                            <span>Select Date</span>
                          </li>
                          <li class="d-flex align-items-center p-3">
                            <div
                              class="mx-datepicker form-control whiteBG pt-0"
                            >
                              <label>From</label>
                              <input
                                class="customflaotField mdb-select md-form form-control pt-0"
                                type="date"
                                v-model="statInfo.from"
                                name="dob1"
                                v-validate="'required|before:beforeTarget'"
                                :max="maxDate()"
                                :class="
                                  (statInfo.from != '' &&
                                  statInfo.from != 'Invalid Date'
                                    ? 'active'
                                    : '') || {
                                    'is-invalid':
                                      submittedRequest && errors.has('dob'),
                                  }
                                "
                                :disabled="disable"
                              />
                            </div>
                            <div class="mx-datepicker">
                              <label>To</label>
                              <input
                                class="customflaotField mdb-select md-form form-control pt-0"
                                type="date"
                                v-model="statInfo.to"
                                name="dob2"
                                v-validate="'required|before:beforeTarget'"
                                :max="maxDate()"
                                :class="
                                  (statInfo.to != '' &&
                                  statInfo.to != 'Invalid Date'
                                    ? 'active'
                                    : '') || {
                                    'is-invalid':
                                      submittedRequest && errors.has('dob'),
                                  }
                                "
                                :disabled="disable"
                              />
                            </div>
                            <div
                              class="closeIcon"
                              @click.prevent="
                                openToggle = !openToggle;
                                statInfo.from = '';
                                statInfo.to = '';
                              "
                            >
                              <feather type="x"></feather>
                            </div>
                          </li>
                          <li class="px-3 pt-3">
                            <a
                              href="#"
                              @click.prevent="eventInterValFl('custom', 'stat')"
                              class="grd_btn greenBG"
                              >Submit</a
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="chart"
              ref="chartdiv"
              style="height: 300px"
              v-if="no_data > 0"
            ></div>
            <div class="chart" ref="chartdiv" v-else>
              <div class="noChartData whiteBG">
                <img
                  src="../../../../static/fxView/images/line-chart.svg"
                  width="120px"
                  alt="Icon"
                />
                <p>No Data</p>
              </div>
            </div>
            <!-- <img src="../../../../static/fxView/images/lineChart.jpg" alt="Icon"> -->
          </div>
        </div>

        <!-- <div class="col-12 space">
                    <div class="whiteBG box-shadow">
                        <div class="tableHead-title d-flex align-items-center justify-content-between mb-2">
                            <label class="font-weight-bold"> Statistics </label>
                            <div class="rtl d-flex align-items-center">
                                <ul class="selectmotr d-flex align-items-center">
                                    <li><a href="#"> 1W</a></li>
                                    <li><a href="#">1M</a></li>
                                    <li><a href="#">3M</a></li>
                                    <li><a href="#">All</a></li>
                                    <li><a href="#">Custom</a></li>
                                </ul>
                                
                            </div>
                        </div>
                    <div class="scrollable-x">
                        <table class="table table-striped focus-on clientLst-table">
                            <thead>
                                <tr>
                                    <th>Link Name</th>
                                    <th>Referal Link</th>
                                    <th>Total Clicks</th>
                                    <th>Verified</th>
                                    <th>Funded</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Registration</td>
                                    <td>https://app.fxview.com/rest-api</td>
                                    <td>560</td>
                                    <td>25</td>
                                    <td>10</td>
                                </tr>     
                               <tr>
                                    <td>Deposit</td>
                                    <td>https://app.fxview.com/rest-api</td>
                                    <td>560</td>
                                    <td>25</td>
                                    <td>10</td>
                                </tr> 
                                <tr>
                                    <td>Registration</td>
                                    <td>https://app.fxview.com/rest-api</td>
                                    <td>560</td>
                                    <td>25</td>
                                    <td>10</td>
                                </tr> 
                                <tr>
                                    <td>Deposit</td>
                                    <td>https://app.fxview.com/rest-api</td>
                                    <td>560</td>
                                    <td>25</td>
                                    <td>10</td>
                                </tr> 
                                <tr>
                                    <td>Registration</td>
                                    <td>https://app.fxview.com/rest-api</td>
                                    <td>560</td>
                                    <td>25</td>
                                    <td>10</td>
                                </tr> 
                                <tr>
                                    <td>Registration</td>
                                    <td>https://app.fxview.com/rest-api</td>
                                    <td>560</td>
                                    <td>25</td>
                                    <td>10</td>
                                </tr> 
                                <tr>
                                    <td>Deposit</td>
                                    <td>https://app.fxview.com/rest-api</td>
                                    <td>560</td>
                                    <td>25</td>
                                    <td>10</td>
                                </tr>                    
                            </tbody>
                        </table>
                       </div>
                        <app-pagination :getList="userList" :pageLimit_parent="pageLimit"></app-pagination>
                    </div>
                </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

// import moment from "moment";
import { fxViewMixins } from "@/plugins/fxView";
export default {
  name: "REFERAL-LINK-ANALYSIS",
  mixins: [fxViewMixins],
  data() {
    return {
      pageTitle: this.$options.name,
      pageLoader: false,
      openToggle: false,
      pageLimit: 15,
      response_msg: "",
      msg_type: "",
      chart_data: [],
      no_data: 0,
      submittedRequest: false,
      ind_dob: "",
      dataType: "register",
      disable: false,
      statInfo: {
        interval: "",
        from: "",
        to: "",
      },
      chart_type: "",
    };
  },
  methods: {
    am4themes_myTheme(target) {
      if (target instanceof am4core.ColorSet) {
        target.list = [am4core.color("green")];
      }
    },
    maxDate() {
      // return moment().format("YYYY-MM-DD");
      const today = new Date()
      const yyyy = today.getFullYear()
      const mm = String(today.getMonth() + 1).padStart(0,0)
      const dd = String(today.getDate()).padStart(0,0);
      return `${yyyy}-${mm}-${dd}`
    },
    eventInterValFl(interval, eventType) {
      if (eventType == "stat") {
        this.statInfo.interval = interval;
        if (this.statInfo.interval != "custom") {
          this.statInfo.from = this.statInfo.to = "";
          this.listing();
        } else if (
          this.statInfo.interval == "custom" &&
          this.statInfo.from != "" &&
          this.statInfo.to != ""
        ) {
          this.listing();
          //this.openToggle = !this.openToggle
        } else if (this.statInfo.interval == "") {
          this.listing();
        }
      }
    },
    listing() {
      let inputJson = {
        globalParams: {
          filter: {},
          sort: [],
          search: this.search,
          page: this.page,
          perPage: this.pageLimit,
          stat_interval: this.statInfo.interval,
          stat_from_interval: this.statInfo.from,
          stat_to_interval: this.statInfo.to,
        },
        localParams: { parameter: this },
      };
      //console.log("inputJson",inputJson)
      //input_json.globalParams.dob   =   moment(_that.ind_dob).format('YYYY-MM-DD')
      this._runGetdashboardChartData(inputJson);
    },
    intializeChart() {
      am4core.addLicense("ch-custom-attribution");
      let chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);

      chart.paddingRight = 20;

      // let visits = 10;
      // for (let i = 1; i < 366; i++) {
      //   visits += Math.round((Math.random() < 0.5 ? 1 : -1) * Math.random() * 10);
      //   data.push({ date: new Date(2018, 0, i), name: "name" + i, value: visits });
      // }

      chart.data = this.chart_data;

      let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.renderer.grid.template.location = 0;

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.tooltip.disabled = true;
      valueAxis.renderer.minWidth = 35;
      if (this.chart_type == "registered") {
        chart.colors.list = [am4core.color("#25c16f")];
      } 
      else if (this.chart_type == "unverified") {
        chart.colors.list = [am4core.color("#ffa003")];
      } 
       else if (this.chart_type == "verified") {
        chart.colors.list = [am4core.color("#cb5482")];
      } 
      
      else if (this.chart_type == "funded") {
        chart.colors.list = [am4core.color("#ff0000")];
      }

      let series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.dateX = "date";
      series.dataFields.valueY = "value";

      series.tooltipText = "{valueY.value}";

      chart.cursor = new am4charts.XYCursor();

      // let scrollbarX = new am4charts.XYChartScrollbar();
      // scrollbarX.series.push(series);
      // chart.scrollbarX = scrollbarX;

      this.chart = chart;
    },
    chartData(data) {
      //console.log("data~",typeof this.dashboardChartData,Object(this.dashboardChartData.registered).length)
      // if (data == "register") {
      //   this.chart_type = data;
      //   if (Object(this.dashboardChartData.registered).length > 0) {
      //     this.no_data = Object(this.dashboardChartData.registered).length;
      //     let lists = [];

      //     let jsonEl = [];
      //     $.each(this.dashboardChartData.registered, function (key, value) {
      //       //console.log("data===>", typeof value.data)
      //       jsonEl = JSON.parse(value.data);
      //       lists.push(jsonEl);
      //     });

      //     if (
      //       Object(this.dashboardChartData.registered).length == lists.length
      //     ) {
      //       //this.chart_data = [{"date": "2021-06-11", "value": 2}]
      //       this.chart_data = lists;
      //       this.intializeChart();
      //     }
      //   } else {
      //     this.no_data = 0;
      //   }
      // }
      
      // else {
      //   this.chart_type = data;
      //   if (Object(this.dashboardChartData.funded).length > 0) {
      //     this.no_data = Object(this.dashboardChartData.funded).length;
      //     let lists = [];

      //     let jsonE2 = [];
      //     $.each(this.dashboardChartData.funded, function (key, value) {
      //       jsonE2 = JSON.parse(value.data);
      //       lists.push(jsonE2);
      //     });
      //     if (Object(this.dashboardChartData.funded).length == lists.length) {
      //       //console.log(this.dashboardChartData.funded.length,"funded",lists)
      //       this.chart_data = lists;
      //       //console.log("lists= ==>", lists)
      //       this.intializeChart();
      //     }
      //   } else {
      //     this.no_data = 0;
      //   }
      // }

        this.chart_type = data;
        if (Object(this.dashboardChartData[data]).length > 0) {
          this.no_data = Object(this.dashboardChartData[data]).length;
          let lists = [];

          let jsonEl = [];
          $.each(this.dashboardChartData[data], function (key, value) {
            //console.log("data===>", typeof value.data)
            jsonEl = JSON.parse(value.data);
            lists.push(jsonEl);
          });

          if (
            Object(this.dashboardChartData[data]).length == lists.length
          ) {
            //this.chart_data = [{"date": "2021-06-11", "value": 2}]
            this.chart_data = lists;
            this.intializeChart();
          }
        } else {
          this.no_data = 0;
        }
      //this.intializeChart()
    },
  },
  created() {
    this.listing();
    this.setData(this.pageTitle);
    const _that = this
    setTimeout(function(){_that.chartData('registered')},300)
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello {
  width: 100%;
  height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/fxView/referal-link/referal_link.vue